import Vue from 'vue';
import Vuex from 'vuex';

import mutations from './user.mutations';
import actions from './user.actions';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    currentUser: null,
    isCurrentUserPremium: false,
    currentUserPremiumExpiryDate: 0
  },
  mutations,
  actions
};
